
// Analytics utility for session recording and event tracking
declare global {
  interface Window {
    clarity: (action: string, ...args: any[]) => void;
  }
}

export const trackEvent = (eventName: string, properties?: Record<string, any>) => {
  // Only track if user has consented and clarity is loaded
  if (typeof window !== 'undefined' && window.clarity && hasAnalyticsConsent()) {
    try {
      window.clarity('event', eventName, properties);
      console.log('Analytics event tracked:', eventName, properties);
    } catch (error) {
      console.error('Error tracking event:', error);
    }
  }
};

export const identifyUser = (userId: string, userProperties?: Record<string, any>) => {
  if (typeof window !== 'undefined' && window.clarity && hasAnalyticsConsent()) {
    try {
      window.clarity('identify', userId, userProperties);
      console.log('User identified for analytics:', userId);
    } catch (error) {
      console.error('Error identifying user:', error);
    }
  }
};

export const setCustomTag = (key: string, value: string) => {
  if (typeof window !== 'undefined' && window.clarity && hasAnalyticsConsent()) {
    try {
      window.clarity('set', key, value);
    } catch (error) {
      console.error('Error setting custom tag:', error);
    }
  }
};

// Analytics consent management
export const getAnalyticsConsent = (): boolean => {
  if (typeof window === 'undefined') return false;
  const consent = localStorage.getItem('analytics_consent');
  return consent === 'true';
};

export const setAnalyticsConsent = (consent: boolean) => {
  if (typeof window !== 'undefined') {
    localStorage.setItem('analytics_consent', consent.toString());
    if (consent) {
      // Initialize tracking if consent is given
      initializeAnalytics();
    }
  }
};

export const hasAnalyticsConsent = (): boolean => {
  return getAnalyticsConsent();
};

const initializeAnalytics = () => {
  // Additional initialization logic if needed
  console.log('Analytics initialized with user consent');
};

// Key events to track
export const AnalyticsEvents = {
  // Authentication
  USER_SIGNED_UP: 'user_signed_up',
  USER_SIGNED_IN: 'user_signed_in',
  USER_SIGNED_OUT: 'user_signed_out',
  
  // Etsy Integration
  ETSY_CONNECTION_STARTED: 'etsy_connection_started',
  ETSY_CONNECTION_COMPLETED: 'etsy_connection_completed',
  ETSY_CONNECTION_FAILED: 'etsy_connection_failed',
  ETSY_ORDERS_SYNCED: 'etsy_orders_synced',
  ETSY_PRODUCTS_SYNCED: 'etsy_products_synced',
  
  // Order Management
  ORDER_VIEWED: 'order_viewed',
  ORDER_UPDATED: 'order_updated',
  ORDER_EXPORTED: 'order_exported',
  ORDER_PRINTED: 'order_printed',
  
  // Subscription
  SUBSCRIPTION_VIEWED: 'subscription_viewed',
  SUBSCRIPTION_UPGRADED: 'subscription_upgraded',
  SUBSCRIPTION_CANCELLED: 'subscription_cancelled',
  
  // Reports
  REPORT_GENERATED: 'report_generated',
  REPORT_EXPORTED: 'report_exported',
  
  // Page Views
  PAGE_VIEWED: 'page_viewed'
} as const;
